module.exports = __webpack_public_path__ + "static/media/02.6c429438.jpg";